import { createContext, useContext, type ReactElement } from 'react';

import type { DeploymentEnvironment } from '@/config/runtimeConfig';

import { Badge, type BadgeTone } from '../kit';

/**
 * Bandeau d'environnement de la barre laterale (maquette B1 : « Prod » en
 * pastille Danger avec point).
 *
 * Il dit **ou** l'on agit avant qu'on agisse : la meme fiche, le meme bouton
 * « Anonymiser » existent en recette et en production. La valeur vient de la
 * configuration d'execution (`resolveEnvironment`), jamais d'une constante : une
 * image construite une fois sert les trois environnements.
 */
export interface EnvironmentBadgeSpec {
  readonly label: string;
  readonly tone: BadgeTone;
  readonly dot: boolean;
}

export const environmentBadge = (environment: DeploymentEnvironment | null): EnvironmentBadgeSpec => {
  switch (environment) {
    case 'prod':
      return { label: 'Prod', tone: 'danger', dot: true };
    case 'recette':
      return { label: 'Recette', tone: 'warning', dot: false };
    case 'dev':
      return { label: 'Local', tone: 'info', dot: false };
    case null:
      return { label: 'Environnement non renseigné', tone: 'neutral', dot: false };
  }
};

const EnvironmentContext = createContext<DeploymentEnvironment | null>(null);

export const EnvironmentProvider = EnvironmentContext.Provider;

export const EnvironmentBadge = (): ReactElement => {
  const spec = environmentBadge(useContext(EnvironmentContext));

  return <Badge label={spec.label} tone={spec.tone} dot={spec.dot} />;
};
